import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-display-ceu',
  templateUrl: './dialog-display-ceu.component.html',
  styleUrls: ['./dialog-display-ceu.component.scss']
})
export class DialogDisplayCeuComponent {
  waitingForData = [];

  columnsToDisplay = [
    'ceu_column_code',
    'ceu_column_name',
    'ceu_column_work_unit',
    'ceu_column_materials',
    'ceu_column_upstream_transport',
    'ceu_column_mixed_manufacturing',
    'ceu_column_incoming_freight',
    'ceu_column_implementation',
    'ceu_column_outgoing_freight',
    'ceu_column_others',
    'ceu_column_total'
  ];

  ceuValues: any;

  constructor(
    public dialogRef: MatDialogRef<DialogDisplayCeuComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ceuValues = data.formula.ceuValues;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
